import React from 'react';
import { Input, Select } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { Search, X, Download } from 'lucide-react';

export const FilterBar = ({
  search,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters = [],
  dateRange = null,
  onClear,
  onExport,
  testId = 'filter-bar'
}) => {
  const hasFilters = search || filters.some(f => f.value) || (dateRange && (dateRange.from || dateRange.to));
  
  return (
    <div className="mb-5" data-testid={testId}>
      <div className="flex flex-wrap items-end gap-2.5">
        <div className="relative flex-1 min-w-[240px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-muted)]" size={14} strokeWidth={2} />
          <Input
            placeholder={searchPlaceholder}
            value={search || ''}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9"
            data-testid={`${testId}-search`}
          />
        </div>
        
        {filters.map((f) => (
          <div key={f.key} className="min-w-[140px]">
            <Select
              value={f.value || ''}
              onChange={(e) => f.onChange(e.target.value)}
              data-testid={`${testId}-${f.key}`}
            >
              <option value="">{f.label}</option>
              {f.options.map(opt => (
                <option key={opt.value || opt} value={opt.value || opt}>
                  {opt.label || opt}
                </option>
              ))}
            </Select>
          </div>
        ))}
        
        {dateRange && (
          <>
            <div className="min-w-[140px]">
              <Input
                type="date"
                value={dateRange.from || ''}
                onChange={(e) => dateRange.onFromChange(e.target.value)}
                data-testid={`${testId}-date-from`}
              />
            </div>
            <div className="min-w-[140px]">
              <Input
                type="date"
                value={dateRange.to || ''}
                onChange={(e) => dateRange.onToChange(e.target.value)}
                data-testid={`${testId}-date-to`}
              />
            </div>
          </>
        )}
        
        <div className="flex gap-2 ml-auto">
          {hasFilters && onClear && (
            <Button type="button" variant="ghost" onClick={onClear} size="sm" data-testid={`${testId}-clear`}>
              <X size={12} />
              Clear
            </Button>
          )}
          {onExport && (
            <Button type="button" variant="outline" onClick={onExport} size="sm" data-testid={`${testId}-export`}>
              <Download size={12} />
              Export
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
